export default __webpack_public_path__ + "static/media/nft_image_1.79fc4066.png";